import {FeatureAppLoader} from '@feature-hub/react';
import { ThemeProvider } from '@volkswagen-onehub/components-core';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import React from 'react';
import { DealerData, VehicleData } from '../../types';
import { LayerCloseHandle } from '../../types/layers';
import { ModelOffers } from '../../types/offers';
import { FeatureServicesContext, useFeatureServices } from '../../use-feature-services';

interface Props {
  close: LayerCloseHandle;
  offer: ModelOffers;
  source: string[];
  vehicle: VehicleData;
  dealer?: DealerData;
}

export default (props: Props) => {
  const featureServiceContext = useFeatureServices();
  const {'featureapp-service': featureAppService} = featureServiceContext;
  const offersUiDefinition = (featureAppService?.featureAppConfigurations as any).offersUi;

  return (
    <ThemeProvider theme="main">
      <FeatureServicesContext.Provider value={featureServiceContext}>
        <FeatureAppLoader
          {...offersUiDefinition}
          beforeCreate={(env) => {
            const contentService = env.featureServices['fa-content-service'] as
            | FaContentServiceV1
            | undefined;

            if (contentService) {
              contentService.content = {
                ...props.offer,
                type: props.source[1],
                source: props.source[0],
                vehicle: props.vehicle,
                dealer: props.dealer
              };
            }

          }}
          featureAppId="offers-feature-app"
          done={() => {
            props.close();
          }}
        >
        </FeatureAppLoader>
      </FeatureServicesContext.Provider>
    </ThemeProvider>
  );
};
